/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_PACKAGE_URL, API_RETURN_PACKAGE_URL, COMMON_HEADER_CONFIG} from "../config";

class PackageService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getList = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PACKAGE_URL}/uploads`,
        params: {
          size: 100,
          page: 1,
          sort: "created_at DESC"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOne = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PACKAGE_URL}/uploads/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  update = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_PACKAGE_URL}/uploads/update`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deletackagecklist = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_PACKAGE_URL}/uploads/delete`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: {ids: [id]}
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePackageIsPrinted = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_PACKAGE_URL}/uploads/update`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getReturnPackageByTradeOrderNumber = (tradeOrderNumber) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_RETURN_PACKAGE_URL}/return-package`,
        params: {
          limit: 10000,
          page: 1,
          trade_order_number_root: tradeOrderNumber
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  exportReductionInvoice = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_RETURN_PACKAGE_URL}/return-package/export-reduction-invoice`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getApproveReturnInvoice = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_RETURN_PACKAGE_URL}/return-package`,
        params,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchReturnPackages = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_RETURN_PACKAGE_URL}/return-package`,
        params: {
          limit: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateReturnPackage = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_RETURN_PACKAGE_URL}/return-package/${data.id}`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateReturnPackageList = (data = []) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_RETURN_PACKAGE_URL}/return-package`,
        data: {data: [...data]},
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const packageService = new PackageService();

export default packageService;
